import { useCallback } from "react";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { CampaignDelete_TopPage_Mutation } from "./mutation";
import { CampaignList_Top_Query } from "../../query/query";

type Props = {
	hotelID: string;
};

export const useCampaignDelete = ({ hotelID }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const { mutationFunc } = useCustomMutation(CampaignDelete_TopPage_Mutation, {
		refetchQueries: [
			{
				query: CampaignList_Top_Query,
				variables: { hotelID },
			},
		],
	});

	const onDeleteVoucher = useCallback(
		(voucherID: string, voucherName: string, inSale: boolean) => {
			if (inSale) {
				notifyUserEventInfo({
					variant: "error",
					title: "公開しているキャンペーンは削除できません",
				});
				return;
			}

			showLoadingScreenCallback();

			mutationFunc({
				variables: {
					hotelID,
					voucherID,
				},
			})
				.then(({ errors }) => {
					if (!errors) {
						notifyUserEventInfo({
							variant: "default",
							title: `キャンペーン(${voucherName})を削除しました`,
						});
					}
				})
				.finally(() => {
					hideLoadingScreenCallback();
				});
		},
		[hideLoadingScreenCallback, hotelID, mutationFunc, showLoadingScreenCallback],
	);

	return {
		onDeleteVoucher,
	};
};
